/**
 * Get division image path from descriptor
 * Division descriptors already include the _multi suffix
 * Example: "Descriptor_Deck_Division_BEL_16e_Mecanisee_multi" -> "/images/divisions/Descriptor_Deck_Division_BEL_16e_Mecanisee_multi.png"
 */
export function getDivisionImagePath(descriptor: string): string {
  return `/images/divisions/${descriptor}.png`;
}

/**
 * Get coalition flag path from alliance string
 * Alliance format: "ECoalition/NATO" or "ECoalition/PACT"
 * Example: "ECoalition/NATO" -> "/images/coalitions/NATO.png"
 */
export function getCoalitionFlagPath(alliance: string): string {
  if (!alliance) return "";
  // Extract coalition name by removing "ECoalition/" prefix
  const coalition = alliance.replace(/^ECoalition\//, "");
  return `/images/coalitions/${coalition}.png`;
}

/**
 * Get country flag path from country code
 * Example: "US" -> "/images/nations/US.png"
 */
export function getCountryFlagPath(country: string): string {
  if (!country) return "";
  return `/images/nations/${country}.png`;
}

